// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Nryo","list":"styles_list__V1-01"};